/**
 * Formats a training focus code to a German description.
 * @param { number } trainingFocus - The code representing the training focus.
 * @returns { string } - The formatted training focus in German.
 */
export const formatTrainingFocus = (trainingFocus) => {
    switch (trainingFocus) {
        case 1: 
            return "Kraft";
        case 2: 
            return "Ausdauer";
        case 3: 
            return "Technik";
        case 4: 
            return "Taktik";
        case 5: 
            return "Koordination";
        case 6: 
            return "Schnelligkeit";
        case 7: 
            return "Wettkampf\nLiga";
        case 8: 
            return "Ruhetag";
        case 9: 
            return "Reisetag";
        case 10: 
            return "Sonstige Aktivität";
        default: 
            return "";
    }
};